var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComoros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40.0001C31.0457 40.0001 40 31.0458 40 20.0001C40 8.95443 31.0457 0.00012207 20 0.00012207C8.95431 0.00012207 0 8.95443 0 20.0001C0 31.0458 8.95431 40.0001 20 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9994 19.9421H18.3189C14.0144 24.2467 11.4115 27.5699 8.75366 30.2277L20.058 31.2464L37.5998 29.5073C39.1306 26.6796 40.0001 23.4414 40.0001 20C40.0001 19.9807 39.9994 19.9615 39.9994 19.9421V19.9421Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75368 10.3769H37.5359C34.1345 4.19188 27.5571 0 20 0C14.4918 0 9.50461 2.22742 5.88782 5.83L8.75368 10.3769Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62326 29.5073C7.82529 31.3052 7.13045 32.8116 5.82959 34.1124C9.45107 37.7489 14.4624 40 20.0001 40C27.6044 40 34.2172 35.7559 37.5998 29.5073H9.62326Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85785 5.79993C-1.95262 13.6104 -1.95262 26.2738 5.85785 34.0843C9.08543 30.8567 12.1896 27.7526 20 19.9421L5.85785 5.79993Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27538 19.9421C5.27538 17.0282 7.32327 14.5939 10.058 13.9967C9.63764 13.9049 9.20155 13.8552 8.75358 13.8552C5.39178 13.8552 2.66663 16.5803 2.66663 19.9421C2.66663 23.3039 5.39178 26.0291 8.75358 26.0291C9.20147 26.0291 9.63756 25.9793 10.058 25.8875C7.32327 25.2902 5.27538 22.856 5.27538 19.9421V19.9421Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99075 14.7247L10.3146 15.7211H11.3622L10.5146 16.337L10.8384 17.3334L9.99075 16.7176L9.14309 17.3334L9.46692 16.337L8.61926 15.7211H9.66692L9.99075 14.7247Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99075 17.3334L10.3146 18.3299H11.3622L10.5146 18.9456L10.8384 19.9421L9.99075 19.3263L9.14309 19.9421L9.46692 18.9456L8.61926 18.3299H9.66692L9.99075 17.3334Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99075 19.9421L10.3146 20.9385H11.3622L10.5146 21.5544L10.8384 22.5508L9.99075 21.935L9.14309 22.5508L9.46692 21.5544L8.61926 20.9385H9.66692L9.99075 19.9421Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99075 22.5508L10.3146 23.5472H11.3622L10.5146 24.1631L10.8384 25.1595L9.99075 24.5437L9.14309 25.1595L9.46692 24.1631L8.61926 23.5472H9.66692L9.99075 22.5508Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComoros);
export default __webpack_public_path__ + "static/media/comoros.ca8515df47eaa7fa120023efe92d11d0.svg";
export { ForwardRef as ReactComponent };